function extractVueFunctions () {
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"frontmatter-markdown"},[_c('h1',[_vm._v("MoodMusic")]),_vm._v(" "),_c('p',[_vm._v("image test: "),_c('img',{attrs:{"src":require("./moodmusic.png"),"alt":"image"}}),_vm._v("\nreadme file\n"),_c('em',[_vm._v("wooo")])])])}]

return { render: render, staticRenderFns: staticRenderFns }
}
const vueFunctions = extractVueFunctions()

module.exports = { 
      attributes: {},
    
      body: "# MoodMusic\r\n\r\nimage test: ![image](./moodmusic.png)\r\nreadme file\r\n_wooo_\r\n",
    
      vue: {
        component: {
          data: function () {
            return {
              templateRender: null
            }
          },
          render: function (createElement) {
            return this.templateRender ? this.templateRender() : createElement("div", "Rendering");
          },
          created: function () {
            this.templateRender = vueFunctions.render;
            this.$options.staticRenderFns = vueFunctions.staticRenderFns;
          }
        }
      },
     }